import React, { Component } from 'react';
import PropTypes from 'prop-types';
import createConfig from './config.js';
import PrivateRoute from './Components/Auth/PrivateRoute';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import { isAdminOrEditor, getFileURL, isDeviceOnline } from './helpers';
import { ToastContainer, toast } from 'react-toastify';
import asyncComponent from './AsyncComponent';
import queryString from 'query-string';
import StoreController from '@projeccions-pdc/frontend-storage';
import UpdaterProgress from './Components/Common/UpdaterProgress';
import AppController from './AppController';
import getCustomizationStyle from './themeCustomizationHelper';
import ToolFrame from './Components/Common/ToolFrame';
// import ImageViewer from './Components/Viewers/ImageViewer';
import AppContext from './AppContext';
import AuthController from './Components/Auth/AuthController';
import DownloadOrShareFile from './Components/Common/DownloadOrShareFile';
import ContainerShareDialog from './Components/Common/MailShareDialog/ContainerShareDialog';
import { Hub } from 'aws-amplify';
import 'react-toastify/dist/ReactToastify.css';
import './fonts/fonts.css';
import './App.css';

import { version } from '../package.json';

import Icon from '@projeccions-pdc/react-icon';

// import Dialog from '@material-ui/core/Dialog';
// import DialogTitle from '@material-ui/core/DialogTitle';
// import DialogContent from '@material-ui/core/DialogContent';
// import DialogContentText from '@material-ui/core/DialogContentText';

import LocalizedStrings from './localization.js';

const AcceptInvitation = asyncComponent('./Components/AcceptInvitation/AcceptInvitation', 'default');
const MyPlatforms = asyncComponent('./Components/Common/MyPlatforms', 'default');
const Share = asyncComponent('./Components/Other/Share', 'default');
const Print = asyncComponent('./Components/Other/Print', 'default');

const NoMatch = asyncComponent('./Components/Common/NoMatch', 'default');
const Loading = asyncComponent('./Components/Common/Loading', 'default');

// const PDFViewer = asyncComponent('./Components/Viewers/NewPDFViewer/PDFViewer', 'default');
const PDFViewerModal = asyncComponent('./Components/Viewers/NewPDFViewer/PDFViewerModal', 'default');
const ImageViewer = asyncComponent('./Components/Viewers/ImageViewer', 'default');
const VideoViewer = asyncComponent('./Components/Viewers/VideoViewer', 'default');
const ContentViewer = asyncComponent('./Components/Common/ContentViewer', 'default');
const CharlyContainer = asyncComponent('./Components/Home/Charly/CharlyContainer', 'default');
const UserManager = asyncComponent('./Components/UserManager/UserManager', 'default');
const Publish = asyncComponent('./Components/Publish/Publish', 'default');
const NotificationsBackend = asyncComponent('./Components/Notifications/index', 'NotificationsBackend');
const LibraryProvider = asyncComponent('./Components/Library/index', 'LibraryProvider');
const SharesManagement = asyncComponent('./Components/SharesManagement/SharesManagement', 'default');
const Visibilities = asyncComponent('./Components/Visibilities/Visibilities', 'default');
const AuthProvider = asyncComponent('./Components/Auth/AuthProvider', 'default');
const Analytics = asyncComponent('./Components/Analytics/Analytics', 'default');
// const FormsApp = asyncComponent('./Components/Forms/index', 'default');
const FormsApp = asyncComponent('./Components/WeCollect/App', 'default');
// const Report = asyncComponent('./Components/Forms/Reports/Report', 'default');
const Report = asyncComponent('./Components/WeCollect/components/Forms/Reports/Report', 'default');
// let iniTime;
// let done = false;
class App extends Component {
    constructor(props) {
        super(props);

        // iniTime = new Date().getTime();

        this._StoreControllerNoPlatform = new StoreController('', '');

        this.state = {
            isImageGalleryOpen: true,
            currentImageGalleryElement: 0,
            imageGalleryElements: [],
            imageGalleryElementIds: [],

            videoViewerIsOpen: false,
            videoViewerVideoUrl: undefined,
            videoViewerContentId: undefined,

            pdfViewerIsOpen: false,
            pdfViewerFileId: undefined,
            pdfViewerSource: undefined,

            currentContent: undefined,

            capabilities: undefined,

            openDownloadOrShareFile: false,
        };

        let appContext = new AppContext();
        appContext.addObserver('mainComponent', this);
        appContext.setToken(undefined, false, 'unknown', false);

        // document.onSynchronizerUpdate = this.onSynchronizerUpdate;

        // setInterval(() => document.onSynchronizerUpdate(Math.random()), 200);

        Hub.listen('auth', this.onHubCapsule, 'MyListener');
    }

    notifyDataHasChanged = () => {
        this.forceUpdate();
    };

    shouldUseCognito = async () => {
        let isOnline = await isDeviceOnline();
        if (process.env.REACT_APP_IS_CONTAINER === 'true' && !isOnline) {
            return false;
        } else {
            return true;
        }
    };

    onHubCapsule = async (capsule) => {
        // console.log('onHubCapsule(): ', capsule);
        // const { channel, payload } = capsule;
        // if (channel === 'auth') {
        //     switch (payload.event) {
        //         case 'signIn':
        //             console.log('App.onHubCapsule() user signed in');
        //             await AuthController.refreshSession();
        //             break;
        //         case 'signUp':
        //             console.log('App.onHubCapsule() user signed up');
        //             break;
        //         case 'signOut':
        //             console.log('App.onHubCapsule() user signed out');
        //             break;
        //         case 'signIn_failure':
        //             console.log('App.onHubCapsule() user sign in failed');
        //             break;
        //     }
        // }
    };

    async componentDidMount() {
        // let mountInit = new Date().getTime();

        let subdomain;
        //console.log('process.env.REACT_APP_IS_CONTAINER', process.env.REACT_APP_IS_CONTAINER, true);
        if (process.env.REACT_APP_IS_CONTAINER !== 'true') {
            subdomain = 'lameta'; // spain vallcompanys planacogida proyeccions dbschenker global comapa grupo frimancha duriber lameta kerrylogistics
            // testing --> test-platform-one test-platform-two

            if (window.location.protocol === 'http:' || window.location.protocol === 'https:') {
                if (
                    window.location.host.indexOf('localhost') < 0 &&
                    window.location.host.indexOf('10.0.0.') < 0 &&
                    window.location.host.indexOf('code') < 0
                ) {
                    const parts = window.location.host.split('.');
                    subdomain = parts[0];
                }
            }
        } else {
            subdomain = this._StoreControllerNoPlatform.get('defaultPlatformId');
        }

        this._StoreController = new StoreController(subdomain, '');

        let appContext = new AppContext();

        let newConfig = await createConfig();

        appContext.setConfig(newConfig);
        await appContext.setPlatformId(subdomain);

        const parsed = queryString.parse(this.context.router.route.location.search);

        if (parsed.k) {
            appContext.setMyInfo({
                platformId: subdomain,
                userSub: 'temporary',
                isAdmin: false,
                name: 'sharedUser',
                email: '',
                groups: { member: [], editor: [] },
            });
            appContext.setMyPlatforms({ platforms: [subdomain], isAdminOf: [] });
            appContext.setCanUsePlatform(true);
            // appContext.setPlatformConfig(undefined);
            await appContext.setToken(parsed.k, true, true, false);
        } else {
            if (process.env.REACT_APP_IS_CONTAINER === 'true') {
                //     console.log('hola');

                //TODO: preload from static data
                let _StoreControllerNoPlatform = new StoreController('', '');
                let isUserInit = _StoreControllerNoPlatform.get('isUserInit');
                let _StoreController = new StoreController(subdomain, '');
                let platformConfig = _StoreController.get('platformConfig');
                let myInfo = _StoreController.get('myInfo');
                let myPlatforms = _StoreControllerNoPlatform.get('myPlatforms');

                if (isUserInit !== undefined && platformConfig !== undefined && myInfo !== undefined && myPlatforms !== undefined) {
                    appContext.setMyInfo(myInfo);
                    appContext.setMyPlatforms(myPlatforms);
                    let canUsePlatform = AppController.updateCanUsePlatform();
                    appContext.setCanUsePlatform(canUsePlatform);
                    appContext.setPlatformConfig(platformConfig);
                    this.refreshPlatformConfig(appContext.getPlatformConfig());
                    await appContext.setToken('offline', false, true, false);
                }
            }
            // if (await this.shouldUseCognito()) {
            //     this.refreshSession();
            // } else {
            //     this.updateContainerAppConfig(subdomain, 'offline');
            //     await this.loadPlatformAndUserData();
            //     appContext.setToken('offline', false, true, false);
            // }

            this.loadSessionAsync(subdomain);

            // this.checkVersion();
        }

        // let platformConfig = await AppController.refreshPlatformConfig();
        // this.refreshPlatformConfig(platformConfig);

        this.loadPlatformConfigAsync();

        let isSharedToken = appContext.getIsSharedToken();
        if (!isSharedToken) {
            if (await this.shouldUseCognito()) {
                this.refreshInterval = setInterval(() => {
                    this.refreshSession();
                }, 30 * 60 * 1000);
            }
        }

        // let mountFin = new Date().getTime();
        // let incr = mountFin - mountInit;
        // console.log(`mount time = ${incr}`);
    }

    loadSessionAsync = async (subdomain) => {
        let appContext = new AppContext();
        if (await this.shouldUseCognito()) {
            this.refreshSession();
        } else {
            this.updateContainerAppConfig(subdomain, 'offline');
            await this.loadPlatformAndUserData();
            appContext.setToken('offline', false, true, false);
        }
    };

    loadPlatformConfigAsync = async () => {
        let platformConfig = await AppController.refreshPlatformConfig();
        this.refreshPlatformConfig(platformConfig);
    };

    refreshSession = () => {
        AuthController.refreshSession(this.props.history);
    };

    componentWillUnmount() {
        let appContext = new AppContext();
        let isSharedToken = appContext.getIsSharedToken();
        if (!isSharedToken) {
            clearInterval(this.refreshInterval);
        }

        appContext.removeObserver('mainComponent');
    }

    refreshPlatformConfig = (platformConfig) => {
        try {
            let customStyle = document.getElementById('pdc-platform-theme-customization');
            this.props.setFontFamily(platformConfig.customStyles !== undefined ? platformConfig.customStyles.fontFamily : undefined);

            // this.props.setPrimaryColor(platformConfig.customStyles !== undefined ? platformConfig.customStyles.primaryColor : undefined);
            // this.props.setSecondaryyColor(platformConfig.customStyles !== undefined ? platformConfig.customStyles.secondaryColor : undefined);

            customStyle.innerHTML = getCustomizationStyle(platformConfig.customStyles);
        } catch (err) {
            console.log('Error while loading theme customization', err);
        }
    };

    loadPlatformAndUserData = async () => {
        await AppController.loadPlatformAndUserData();
    };

    refreshMyPlatforms = async () => {
        await AuthController.refreshAuthenticatedUser();
        await AuthController.refreshSession(this.props.history);
        let newState = await AppController.refreshMyPlatforms();
        let appContext = new AppContext();
        appContext.setMyPlatforms(newState.myPlatforms);
        appContext.setCanUsePlatform(newState.canUsePlatform);

        this.forceUpdate();
    };

    logout = async () => {
        return AuthController.signOut(this.props.history);
    };

    updateContainerAppConfig = () => {
        if (process.env.REACT_APP_IS_CONTAINER === 'true') {
            //TABLET & SMARTPHONE
            AppController.updateContainerAppConfig();
        }
    };

    notify = (type, body, toastId) => {
        if (toastId && toast.isActive(toastId)) {
            toast.update(toastId, { render: body, type: type });
            return toastId;
        } else {
            if (body) {
                if (type) {
                    return toast[type](body);
                } else {
                    return toast(body);
                }
            }
        }
    };

    // onSynchronizerUpdate = (percentage) => {
    //     console.log('onSynchronizerUpdate', percentage);
    //     this.setState({ updateProgress: percentage });
    // }

    closeImageGallery = () => {
        this.setState({ isImageGalleryOpen: false, imageGalleryElements: [], currentImageGalleryElement: 0 });
    };

    gotoNextImageGallery = () => {
        let images = this.state.imageGalleryElements;
        let photoIndex = this.state.currentImageGalleryElement;
        let newIndex = photoIndex + 1;
        if (newIndex > images.length - 1) {
            newIndex = images.length - 1;
        }
        this.setState({
            currentImageGalleryElement: newIndex,
        });
    };

    gotoPrevImageGallery = () => {
        let photoIndex = this.state.currentImageGalleryElement;
        let newIndex = photoIndex - 1;
        if (newIndex < 0) {
            newIndex = 0;
        }
        this.setState({
            currentImageGalleryElement: newIndex,
        });
    };

    openImageGallery = (selectedFileId, files) => {
        let elements = files.map((fileId) => {
            return { src: getFileURL(fileId), fileId };
        });
        this.setState({
            isImageGalleryOpen: true,
            currentImageGalleryElement: files.indexOf(selectedFileId),
            imageGalleryElements: elements,
            // imageGalleryElementIds: files
        });
    };

    closeDownloadOrShareFileModal = () => {
        this.setState({ openDownloadOrShareFile: false });
    };

    registerEvent = (resourceId, resourceType, resourceSubtype, extraParams, source, name) => {
        // Tenir en compte diff time entre continguts per veure quan s'ha passat en cada apartat, de tota manera
        // CAL TENIR EN COMPTE si es passa per Charly o altres llocs que el temps no hauria de comptabilitzar, tipus estar a l'editor
        console.log('New event', new Date().toLocaleString(), resourceId, resourceType, resourceSubtype, extraParams, source, name);
    };

    openFileViewer = async (fileId, fileType, urlModifier, source) => {
        let response = await AppController.isContainerCapable(fileId);
        let contentType = response.contentType;
        let isCapable = response.isCapable;
        this.registerEvent(fileId, 'file', fileType, urlModifier, source);
        if (isCapable) {
            return AppController.openFileInContainer(fileId);
        } else {
            if (fileType === 'file') {
                // console.log('contentType 1', contentType);
                if (!contentType) {
                    contentType = await AppController.getFileContentType(fileId, urlModifier);
                }
                // console.log('contentType 2', contentType);
                if (contentType === 'application/pdf') {
                    this.setState({ pdfViewerIsOpen: true, pdfViewerFileId: fileId, pdfViewerSource: source });
                    // } else if (process.env.REACT_APP_IS_CONTAINER === 'true') {
                    //     return AppController.openFileInContainer(fileId);
                } else {
                    // downloadFile(getFileURL(fileId, urlModifier));
                    this.setState({
                        openDownloadOrShareFile: true,
                        downloadOrShareFileId: fileId,
                        downloadOrShareUrlModifier: urlModifier,
                    });
                }
            } else if (fileType === 'video') {
                this.setState({
                    videoViewerIsOpen: true,
                    videoViewerVideoUrl: getFileURL(fileId, urlModifier, source),
                    videoViewerContentId: fileId,
                });
            } else if (fileType === 'image') {
                let elements = [{ src: getFileURL(fileId, urlModifier, source), fileId }];
                this.setState({
                    isImageGalleryOpen: true,
                    currentImageGalleryElement: 0,
                    imageGalleryElements: elements,
                    // imageGalleryElementIds: [fileId]
                });
            } else {
                console.warn('openFileViewer for fileType not implemented', fileType);
            }
        }
    };

    openContent = (contentId, contentType, action, evt, source) => {
        // console.log('openContent', contentId, contentType, action, evt)
        let uri;
        if (!action) {
            action = 'show';
        }
        // this.registerEvent(contentId, 'content', contentType, action, source); already on onContentLoad
        if (contentType === 'm') {
            uri = `/metadocument/${action}/${contentId}?s=${source}`;
        } else if (contentType === 'mtg') {
            uri = `/metadocument/${action}/${contentId}?mtg=${contentId}&s=${source}`;
        } else if (contentType === 'col') {
            uri = `/metadocument/${action}/${contentId}?col=${contentId}&s=${source}`;
        } else if (contentType === 'c') {
            uri = `/category/${action}/${contentId}?s=${source}`;
        }

        if (evt && (evt.ctrlKey || evt.metaKey)) {
            window.open(uri, '_blank');
        } else {
            this.props.history.push(uri);
        }
    };

    openLink = (data) => {
        // console.log('onOpenLink');
        let appContext = new AppContext();
        let config = appContext.getConfig();
        let baseUrl;
        if (typeof data === 'object') {
            baseUrl = data.links.url;
        } else {
            baseUrl = data;
        }
        let isPDC = baseUrl.indexOf(config.PdcDomain) !== -1;
        let destPlatformId;
        if (isPDC) {
            //let baseUrl = 'https://proyeccions.pirami.de/inside/m/H16GTWT5-';
            let aux = baseUrl.split('/');
            let base = aux.filter((value) => {
                return value.indexOf(config.PdcDomain) !== -1;
            })[0];
            destPlatformId = base.split('.')[0];
        }

        let platformId = appContext.getPlatformId();
        let isSamePDC = destPlatformId === platformId;

        if (process.env.REACT_APP_IS_CONTAINER === 'true') {
            if (isPDC) {
                //CHANGE PLATFORMID
                this.setState({ platformId: destPlatformId }, () => {
                    //GO TO URL
                    let path = baseUrl.replace(`https://${destPlatformId}.${config.PdcDomain}`, '');
                    this.props.history.push(path);
                });
            } else {
                //OPEN LINK NATIVE
                AppController.openLinkInContainer(data);
            }
        } else {
            if (isPDC) {
                if (isSamePDC) {
                    //go to URL

                    let path = baseUrl.replace(`https://${platformId}.${config.PdcDomain}`, '');
                    this.props.history.push(path);
                } else {
                    //OPEN URL IN NEW TAB
                    window.open(baseUrl, '_blank');
                }
            } else {
                //OPEN LINK IN NEW TAB
                window.open(baseUrl, '_blank');
            }
        }
    };

    closePdfViewer = () => {
        this.setState({ pdfViewerIsOpen: false, pdfViewerFileId: undefined });
    };

    closeConfirmation = () => {
        this.setState({
            videoViewerIsOpen: false,
            videoViewerVideoUrl: undefined,
            videoViewerContentId: undefined,
        });
    };

    onContentLoad = (contentData) => {
        this.registerEvent(contentData.contentId, 'content', contentData.contentType, undefined, undefined, contentData.name);
        this.setState({ currentContent: contentData });
    };

    checkVersion = () => {
        if (process.env.REACT_APP_IS_CONTAINER !== 'true') {
            try {
                let appContext = new AppContext();
                let config = appContext.getConfig();
                fetch(`https://code.${config.PdcDomain}/version.json`)
                    .then((response) => response.json())
                    .then((data) => {
                        if (version < data.version) {
                            this.notify(
                                'info',
                                <div onClick={() => window.location.reload()}>
                                    {LocalizedStrings.newVersion}
                                    <br />
                                    <span style={{ textDecoration: 'underline' }}>{LocalizedStrings.reloadPage}</span>{' '}
                                    <Icon
                                        name={'md-cached'}
                                        primaryColor="#fff"
                                        // padding={8}
                                    />
                                </div>
                            );
                            setTimeout(this.checkVersion, 10 * 60 * 1000);
                        } else {
                            setTimeout(this.checkVersion, 60 * 1000);
                        }
                    });
            } catch (e) {}
        }
    };

    render() {
        // console.log('render');
        let appContext = new AppContext();
        let config = appContext.getConfig();
        let myPlatforms = appContext.getMyPlatforms();
        let myInfo = appContext.getMyInfo();
        let redirect = appContext.getRedirectLogin();
        let platformId = appContext.getPlatformId();
        let canUsePlatform = appContext.getCanUsePlatform();
        let isSharedToken = appContext.getIsSharedToken();
        let platformConfig = appContext.getPlatformConfig();

        if (config === undefined) {
            return '';
        }

        let indexHtmlRedirection = <Redirect exact from="/index.html" to="/" />;

        let tempPlatformId = platformId ? platformId : 'default';
        let loginCustomization = {
            logo: `${config.PlatformConfiguration}platform-config/${tempPlatformId}/logo.png`,
            logoNegative: `${config.PlatformConfiguration}platform-config/${tempPlatformId}/logo-negative.png`,
            backgroundImage: `${config.PlatformConfiguration}platform-config/${tempPlatformId}/background.png`,
            stackBackgroundImage: `${config.PlatformConfiguration}platform-config/default/stack-background.png`,
            secondaryLogo: `${config.PlatformConfiguration}platform-config/${tempPlatformId}/secondary-logo.png`,
        };

        let customization = {
            logo: 'logo.png',
            logoNegative: 'logo-negative.png',
            backgroundImage: 'background.png',
            secondaryLogo: 'secondary-logo.png',
        };

        let loginRoute = (
            // <Route
            //     exact
            //     path="/login"
            //     render={routeProps => (
            //         <LoginProvider
            //             config={config}
            //             token={appContext.getToken()}
            //             {...routeProps}
            //             notify={this.notify}
            //             getDownloadLink={() => getDownloadLink()}
            //             callback={this.refreshSession}
            //             customization={loginCustomization}
            //         />
            //     )}
            // />
            <Route
                path="/login"
                render={(routeProps) => (
                    <AuthProvider
                        {...routeProps}
                        notify={this.notify}
                        // getDownloadLink={() => getDownloadLink()}
                        customization={loginCustomization}
                    />
                )}
            />
        );
        let noMatchRoute = <Route component={NoMatch} />;
        let toastContainer = (
            <ToastContainer
                position="bottom-center"
                type="default"
                autoClose={5000}
                hideProgressBar={true}
                newestOnTop={false}
                closeOnClick
                pauseOnHover
                pauseOnVisibilityChange={false}
            />
        );
        // console.log('step1', myPlatforms, platformConfig);
        if (myPlatforms !== undefined && platformConfig !== undefined) {
            //if (false) {
            let acceptInvitationRoute = (
                <PrivateRoute
                    path="/accept-invitation/:platformId/:invCode"
                    exact
                    component={AcceptInvitation}
                    notify={this.notify}
                    customization={customization}
                    refreshMyPlatforms={this.refreshMyPlatforms}
                    logout={this.logout}
                />
            );
            // console.log('step2', myInfo, platformId, canUsePlatform);
            let reportRoute = <PrivateRoute path="/report/:reportId?" component={Report} notify={this.notify} isSnapshot={true} />;
            if (myInfo !== undefined && platformId && canUsePlatform) {
                // if (false) {
                // if (done === false) {
                //     done = true;
                //     let fin = new Date().getTime();
                //     let increment = fin - iniTime;
                //     console.info(`loadTime = ${increment}`);

                //     let incrTotal = fin - document.initAppTime;
                //     console.info(`totalTime = ${incrTotal}`);
                // }
                // return (
                //     <div>
                //         loaded!!!!
                //     </div>
                // );
                let shareRoute = (
                    <PrivateRoute
                        path="/share/:type?(category|metadocument|fileviewer)/:contentId?"
                        component={Share}
                        openFileViewer={this.openFileViewer}
                        openLink={this.openLink}
                        openImageGallery={this.openImageGallery}
                        notify={this.notify}
                        openContent={this.openContent}
                    />
                );
                let printRoute = (
                    <PrivateRoute
                        path="/print/:type?(category|metadocument|fileviewer)/:contentId?"
                        component={Print}
                        openFileViewer={this.openFileViewer}
                        openLink={this.openLink}
                        openImageGallery={this.openImageGallery}
                        notify={this.notify}
                        openContent={this.openContent}
                    />
                );
                

                let viewerComponents = [
                    <div key="image-gallery">
                        {this.state.isImageGalleryOpen && this.state.imageGalleryElements.length > 0 && (
                            <ImageViewer
                                currentImageGalleryElement={this.state.currentImageGalleryElement}
                                imageGalleryElements={this.state.imageGalleryElements}
                                notify={this.notify}
                                closeImageGallery={this.closeImageGallery}
                                gotoPrevImageGallery={this.gotoPrevImageGallery}
                                gotoNextImageGallery={this.gotoNextImageGallery}
                            />
                        )}
                    </div>,
                    <VideoViewer
                        key="video-viewer"
                        isOpen={this.state.videoViewerIsOpen}
                        closeModal={this.closeConfirmation}
                        videoUrl={this.state.videoViewerVideoUrl}
                        fileId={this.state.videoViewerContentId}
                        notify={this.notify}
                    />,
                    <PDFViewerModal
                        key="pdf-viewer"
                        isOpen={this.state.pdfViewerIsOpen}
                        closeModal={this.closePdfViewer}
                        fileId={this.state.pdfViewerFileId}
                        source={this.state.pdfViewerSource}
                        notify={this.notify}
                    />,
                    <DownloadOrShareFile
                        key="file-download-share"
                        open={this.state.openDownloadOrShareFile}
                        fileId={this.state.downloadOrShareFileId}
                        urlModifier={this.state.downloadOrShareUrlModifier}
                        onClose={this.closeDownloadOrShareFileModal}
                        notify={this.notify}
                    />,
                ];
                if (isSharedToken) {
                    return (
                        <div>
                            <Switch>
                                {indexHtmlRedirection}
                                {shareRoute}
                                {printRoute}
                                {reportRoute}
                                {noMatchRoute}
                            </Switch>
                            {toastContainer}
                            {viewerComponents}
                        </div>
                    );
                } else {
                    // const outOffSync = false;
                    return (
                        <div>
                            {/* <div style={{ position: 'absolute', top: 0, right: 20 }}>
                                {outOffSync === true ? (
                                    <Icon
                                        name={'md-sync-problem'}
                                        primaryColor="#F00"
                                        // padding={8}
                                    />
                                ) : (
                                    <Icon
                                        name={'md-sync'}
                                        primaryColor="#0F0"
                                        // padding={8}
                                    />
                                )}
                            </div>
                            <Dialog onClose={() => console.log('close')} aria-labelledby="simple-dialog-title" open={outOffSync}>
                                <DialogTitle id="simple-dialog-title">Versión antigua del contenido</DialogTitle>
                                <DialogContent>
                                    <DialogContentText>
                                        Atención, está visualizando una versión antigua del contenido, por favor{' '}
                                        <strong>connéctese a internet para poder visualizar la última versión</strong>
                                    </DialogContentText>
                                </DialogContent>
                            </Dialog> */}
                            <Switch>
                                {platformId === 'brandhub' ? (
                                    <Redirect exact from="/" to="category/show/" />
                                ) : (
                                    <Redirect exact from="/" to="/home" />
                                )}
                                {/* {platformId === 'brandhub' && <Redirect exact from="/home" to="category/show/" />} */}
                                {indexHtmlRedirection}
                                {loginRoute}
                                <PrivateRoute
                                    path="/home"
                                    exact
                                    component={CharlyContainer}
                                    notify={this.notify}
                                    customization={customization}
                                    openContent={this.openContent}
                                    openFileViewer={this.openFileViewer}
                                    onOpenLink={this.openLink}
                                />
                                <PrivateRoute path="/share-dialog" exact component={ContainerShareDialog} notify={this.notify} />
                                {acceptInvitationRoute}
                                {shareRoute}
                                {printRoute}
                                {reportRoute}
                                {isAdminOrEditor() === true
                                    ? [
                                          <PrivateRoute
                                              path="/analytics"
                                              exact
                                              key="analytics"
                                              component={ToolFrame}
                                              toolComponent={Analytics}
                                              currentLanguage={this.state.currentLanguage}
                                              notify={this.notify}
                                              openContent={this.openContent}
                                              openFileViewer={this.openFileViewer}
                                          />,
                                          <PrivateRoute
                                              path="/library"
                                              exact
                                              key="library"
                                              component={ToolFrame}
                                              toolComponent={LibraryProvider}
                                              currentLanguage={this.state.currentLanguage}
                                              notify={this.notify}
                                              openContent={this.openContent}
                                              openFileViewer={this.openFileViewer}
                                          />,
                                          <PrivateRoute
                                              path="/publish"
                                              exact
                                              key="publish"
                                              component={ToolFrame}
                                              toolComponent={Publish}
                                              notify={this.notify}
                                              openContent={this.openContent}
                                          />,
                                          <PrivateRoute
                                              path="/usermanagement"
                                              exact
                                              key="usermanagement"
                                              component={ToolFrame}
                                              toolComponent={UserManager}
                                              notify={this.notify}
                                          />,
                                          <PrivateRoute
                                              path="/notifications/:notificationId?/"
                                              exact
                                              key="notifications"
                                              component={ToolFrame}
                                              toolComponent={NotificationsBackend}
                                              notify={this.notify}
                                          />,
                                          <PrivateRoute
                                              path="/visibilities"
                                              exact
                                              key="visibilities"
                                              component={ToolFrame}
                                              toolComponent={Visibilities}
                                              notify={this.notify}
                                          />,
                                          <PrivateRoute
                                              path="/forms/:section?/:locator?"
                                              exact
                                              key="forms"
                                              component={ToolFrame}
                                              toolComponent={FormsApp}
                                              notify={this.notify}
                                          />,
                                          <PrivateRoute
                                              path="/forms"
                                              key="forms"
                                              component={ToolFrame}
                                              toolComponent={FormsApp}
                                              notify={this.notify}
                                          />,
                                          <PrivateRoute
                                              path="/configuration"
                                              exact
                                              key="configuration"
                                              component={ToolFrame}
                                              toolComponent={InContruction}
                                              notify={this.notify}
                                          />,
                                      ]
                                    : ''}
                                <PrivateRoute
                                    path="/shared"
                                    exact
                                    component={ToolFrame}
                                    toolComponent={SharesManagement}
                                    notify={this.notify}
                                    openContent={this.openContent}
                                    openFileViewer={this.openFileViewer}
                                />
                                <PrivateRoute
                                    path="/:contentType(category|metadocument)/:action(show|edit)/:contentId?"
                                    exact
                                    component={ContentViewer}
                                    openFileViewer={this.openFileViewer}
                                    openLink={this.openLink}
                                    openImageGallery={this.openImageGallery}
                                    onContentLoad={this.onContentLoad}
                                    currentContent={this.state.currentContent}
                                    notify={this.notify}
                                    openContent={this.openContent}
                                />
                                {noMatchRoute}
                            </Switch>
                            {toastContainer}
                            <UpdaterProgress
                                // updateProgressValue={this.state.updateProgress}
                                size={100}
                                progressColor={'#efefef'}
                            />
                            {viewerComponents}
                        </div>
                    );
                }
            } else {
                return (
                    <div>
                        <Switch>
                            {indexHtmlRedirection}
                            {acceptInvitationRoute}
                            {reportRoute}
                            <Route
                                path="/"
                                render={() => {
                                    return (
                                        <MyPlatforms
                                            customization={customization}
                                            notify={this.notify}
                                            refreshMyPlatforms={this.refreshMyPlatforms}
                                            logout={this.logout}
                                        />
                                    );
                                }}
                            />
                        </Switch>
                        {toastContainer}
                    </div>
                );
            }
        } else {
            //NOTE: the order is important, if /login go to login, if in another route if must redirect then redirect, if not show loading
            let fromPathname =
                this.context.router &&
                this.context.router.route &&
                this.context.router.route.location &&
                this.context.router.route.location.pathname;
            fromPathname = fromPathname || '/';
            return (
                <div>
                    <Switch>
                        {indexHtmlRedirection}
                        {loginRoute}
                        {redirect && <Redirect to={`/login?f=${fromPathname}`} />}
                        <Route exact path="/" render={(routeProps) => <Loading customization={customization} />} />
                    </Switch>
                    {toastContainer}
                </div>
            );
        }
    }
}
App.contextTypes = {
    router: PropTypes.shape({
        history: PropTypes.shape({
            push: PropTypes.func.isRequired,
            replace: PropTypes.func.isRequired,
        }).isRequired,
        staticContext: PropTypes.object,
    }).isRequired,
};

App.propTypes = {
    history: PropTypes.object,
    location: PropTypes.object,
    setFontFamily: PropTypes.func.isRequired,
};

class InContruction extends Component {
    render() {
        return <div>Component in contruction...</div>;
    }
}

export default withRouter(App);
